import template from '@westwing/ui-kit/template';
import {
    FETCH_DYNAMIC_SEARCH_SUGGESTIONS,
    CLEAR_DYNAMIC_SEARCH_SUGGESTIONS,
    FETCH_DYNAMIC_SEARCH_SUGGESTIONS_SUCCESS,
    FETCH_DYNAMIC_SEARCH_SUGGESTIONS_FAILED,
    DynamicSearchSuggestion,
    DynamicSearchSuggestionsActionTypes,
    DynamicSearchSuggestionsState,
    DynamicSearchSuggestionsQueryResponse,
    SET_DYNAMIC_SEARCH_QUERY,
    ENTER_KEY_DYNAMIC_SEARCH_ACTION,
    REAL_DYNAMIC_SEARCH_ACTION,
    FETCH_DYNAMIC_SEARCH_REDIRECT_SUCCESS,
    FETCH_DYNAMIC_SEARCH_REDIRECT,
    FETCH_DYNAMIC_SEARCH_REDIRECT_FAIL,
    RedirectSuggestionResponse,
    DynamicSearchSuggestionBucket,
    CLICKED_DYNAMIC_SEARCH_SUGGESTION_ACTION,
    CLEAR_DYNAMIC_SEARCH_METRICS,
} from './types';

const mapApiResponseToSearchData = (
    redirectSuggestionResponse: RedirectSuggestionResponse
): DynamicSearchSuggestionBucket => ({
    title: redirectSuggestionResponse.title || '',
    urlKey: redirectSuggestionResponse.url_key || '',
    highlight: redirectSuggestionResponse.highlight || '',
    productCount: redirectSuggestionResponse.productCount || 0,
    redirectMethod: redirectSuggestionResponse.redirect_method || '',
});

const initialState: DynamicSearchSuggestionsState = {
    isFetching: false,
    didInvalidate: false,
    query: '',
    isEnterKeySearch: false,
    isRealSearch: false,
    suggestions: [],
    searchRedirect: {
        categories: [],
        brands: [],
        products: [],
        staticPages: [],
    },
    clickedSuggestion: '',
};
export const mapApiResponseToDynamicSearchData = (
    response: DynamicSearchSuggestionsQueryResponse
): DynamicSearchSuggestion => {
    const highlight = response.highlight || '';

    return {
        name: response.name || '',
        highlightHtml: highlight ? template(highlight) : '',
    };
};

// eslint-disable-next-line complexity
export default function dynamicSearchSuggestionsReducer(
    state = initialState,
    action: DynamicSearchSuggestionsActionTypes
): DynamicSearchSuggestionsState {
    switch (action.type) {
        case SET_DYNAMIC_SEARCH_QUERY:
            return {
                ...state,
                query: action.payload.query,
            };
        case ENTER_KEY_DYNAMIC_SEARCH_ACTION:
            return {
                ...state,
                isEnterKeySearch: action.payload.isEnterKeySearch,
            };
        case REAL_DYNAMIC_SEARCH_ACTION:
            return {
                ...state,
                isRealSearch: action.payload.isRealSearch,
            };
        case CLICKED_DYNAMIC_SEARCH_SUGGESTION_ACTION:
            return {
                ...state,
                clickedSuggestion: action.payload.clickedSuggestion,
            };
        case FETCH_DYNAMIC_SEARCH_SUGGESTIONS:
        case FETCH_DYNAMIC_SEARCH_REDIRECT:
            return {
                ...state,
                isFetching: true,
            };
        case FETCH_DYNAMIC_SEARCH_SUGGESTIONS_SUCCESS: {
            const { data = {} } = action.payload;
            const { queries = [] } = data;
            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                suggestions: queries.map(mapApiResponseToDynamicSearchData),
            };
        }
        case FETCH_DYNAMIC_SEARCH_REDIRECT_SUCCESS: {
            const { data = {} } = action.payload;
            const { Categories = [] } = data;
            const { Brands = [] } = data;
            const { Products = [] } = data;
            const { StaticPages = [] } = data;

            return {
                ...state,
                isFetching: false,
                didInvalidate: false,
                searchRedirect: {
                    categories: Categories.map(mapApiResponseToSearchData),
                    brands: Brands.map(mapApiResponseToSearchData),
                    products: Products.map(mapApiResponseToSearchData),
                    staticPages: StaticPages.map(mapApiResponseToSearchData),
                },
            };
        }
        case FETCH_DYNAMIC_SEARCH_SUGGESTIONS_FAILED:
        case FETCH_DYNAMIC_SEARCH_REDIRECT_FAIL:
            return {
                ...state,
                isFetching: false,
                didInvalidate: true,
                error: action.payload,
            };
        case CLEAR_DYNAMIC_SEARCH_SUGGESTIONS: {
            const { exemptQuery } = action.payload;
            const newState = {
                ...initialState,
                clickedSuggestion: state.clickedSuggestion,
            };
            return exemptQuery ? { ...newState, query: state.query } : newState;
        }
        case CLEAR_DYNAMIC_SEARCH_METRICS:
            return {
                ...state,
                isRealSearch: initialState.isRealSearch,
                clickedSuggestion: initialState.clickedSuggestion,
            };

        default: {
            return state;
        }
    }
}
